declare const __SDK_VERSION__: string;
export const SDK_VERSION: string = __SDK_VERSION__;
